export interface ModelConfig {
  name: string;
  provider: "fal" | "openai";
  sizeParam?: "aspect_ratio" | "image_size";
  sizeFormat?: "preset" | "object";
}

export const MODELS: Record<string, ModelConfig> = {
  "openai/gpt-image-2": {
    name: "GPT Image 2",
    provider: "fal",
    sizeParam: "aspect_ratio",
  },
  "openai/gpt-image-2.5/flare/text-to-image": {
    name: "GPT Image 2.5 Flare",
    provider: "fal",
    sizeParam: "aspect_ratio",
  },
  "fal-ai/recraft-v3": {
    name: "Recraft V3",
    provider: "fal",
    sizeParam: "image_size",
    sizeFormat: "object",
  },
  "fal-ai/nano-banana-2": { name: "Nano Banana 2", provider: "fal", sizeParam: "aspect_ratio" },
  "fal-ai/nano-banana-pro": { name: "Nano Banana Pro", provider: "fal", sizeParam: "aspect_ratio" },
};

export const ASPECT_RATIOS = [
  { value: "16:9", label: "16:9 (Landscape)" },
  { value: "9:16", label: "9:16 (Portrait)" },
  { value: "1:1", label: "1:1 (Square)" },
  { value: "4:3", label: "4:3" },
  { value: "3:4", label: "3:4" },
  { value: "3:2", label: "3:2" },
  { value: "2:3", label: "2:3" },
  { value: "21:9", label: "21:9 (Ultra-wide)" },
  { value: "5:4", label: "5:4" },
  { value: "4:5", label: "4:5" },
];

export const MODEL_GROUPS = [
  {
    label: "Recommended",
    models: ["openai/gpt-image-2", "openai/gpt-image-2.5/flare/text-to-image"],
  },
  { label: "High Quality", models: ["fal-ai/recraft-v3"] },
  { label: "Fast", models: ["fal-ai/nano-banana-2", "fal-ai/nano-banana-pro"] },
];
